import { Link, useLocation } from 'react-router-dom';

import { useI18n } from '@/providers/i18n';

import styles from './NotFoundPage.module.css';

export default function NotFoundPage() {
  const { t } = useI18n();
  const { pathname } = useLocation();

  return (
    <section className={styles.root}>
      <span className="nano">/ 404 / NO SIGNAL</span>
      <h1 className={styles.title}>404</h1>
      <p className={styles.body}>
        No transmission at <code>{pathname}</code>. The route does not exist, has been archived,
        or never made it on air.
      </p>
      <div className={styles.actions}>
        <Link to="/" className="btn btn-fill btn-arrow">
          RETURN TO INDEX
        </Link>
        <Link to="/events" className="btn btn-ghost">
          {t('label.upcoming')}
        </Link>
      </div>
    </section>
  );
}
